module.exports = __webpack_public_path__ + "img/screenshot.f0fcc7f2.png";